import * as React from 'react'
import Frame, { FrameContextConsumer } from 'react-frame-component'

interface Props {
  children: any
}

interface State {
  frameContext: any
  frameHeight: 0
}

export default class MailContainer extends React.Component<Props, State> {
  constructor(props) {
    super(props)

    this.state = {
      frameContext: null,
      frameHeight: 0,
    }
  }

  render() {
    return (
      <div onKeyDown={this.validateTagDeletion.bind(this)}>
        <Frame style={this.getStyle()} contentDidUpdate={this.didUpdate.bind(this)}>
          <FrameContextConsumer>
            {frameContext => this.consumer(frameContext)}
          </FrameContextConsumer>
        </Frame>
      </div>
    )
  }

  private validateTagDeletion(e) {
    const key = e.key

    try {
      const win = this.state.frameContext.window
      const selection = win.getSelection()
      const anchor = selection.anchorNode
      const parent = anchor.parentNode

      if (parent.classList.contains('tag')) {
        if (key === 'Backspace') {
          parent.remove()
        } else {
          e.preventDefault()
          e.stopPropagation()
        }
      }
    } catch {}
  }

  private getStyle() {
    return { width: '100%', height: this.state.frameHeight, border: 0, overflow: 'none' }
  }

  public didUpdate() {
    const newHeight = this.state.frameContext.document.body.clientHeight + 18

    if (newHeight !== this.state.frameHeight) {
      setTimeout(() => this.setState({ frameHeight: newHeight }))
    }
  }

  private consumer(frameContext) {
    if (!this.state.frameContext) {
      this.setState({ frameContext })
    }

    return this.props.children
  }
}